import type { IBinderRegistry } from '../interface';
import type { IContainer } from '../interface/container';
import log from './log';

/* eslint-disable-next-line no-restricted-globals */
const globalStorage: Record<string, unknown> = typeof window === 'undefined' ? globalThis : window;

const KEY_CONTAINER = 'container';
const KEY_REGISTRY = 'binder';

export default Object.freeze({
    getContainerMap: () => {
        let value = globalStorage[KEY_CONTAINER] as
            | Record<string, IContainer | undefined>
            | undefined;

        if (!value) {
            log.warn('No containers found! Creating new');
            value = {};
            globalStorage[KEY_CONTAINER] = value;
        }

        return value;
    },
    setContainerMap: (newValue: Record<string, IContainer | undefined> | undefined) =>
        (globalStorage[KEY_CONTAINER] = newValue),

    getBinderMap: () => {
        let value = globalStorage[KEY_REGISTRY] as
            | Record<string, IBinderRegistry | undefined>
            | undefined;

        if (!value) {
            log.warn('No binders found! Creating new');
            value = {};
            globalStorage[KEY_REGISTRY] = value;
        }

        return value;
    },
    setBinderMap: (newValue: Record<string, IBinderRegistry | undefined> | undefined) =>
        (globalStorage[KEY_REGISTRY] = newValue),
});
